module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/cq01.0cf7d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/blog/cq01.jpg
// module id = nTA4
// module chunks = 0